import { customizeHeader } from 'components/ReportGrid_New/utils/customizeHeader';
import { CoveaReport as CoveReportType } from '../../../api/resources/models/AutoGenerated';
import { Workbook } from 'exceljs';
import domtoimage from 'dom-to-image';
import { convertBlobToBase64 } from '../../../utils/helpers';
import { rootChartContainerId } from './constants';

export async function createRepairStatusUsageSummarySheet(
  workbook: Workbook,
  headerImageId: number,
  reportHeaderTagLine?: string,
  headerTitleForSheet?: string,
  reportData?: CoveReportType
) {
  const graphSheet = workbook.addWorksheet('Repair status usage summary', {
    properties: { defaultColWidth: 20 },
  });
  const newGraphSheet = workbook.getWorksheet('Repair status usage summary');

  customizeHeader(newGraphSheet, reportHeaderTagLine, headerTitleForSheet);
  const chart = document.querySelector(`#${rootChartContainerId}`) as Node;
  if (!chart) {
    return;
  }
  const blobData = await domtoimage.toBlob(chart);
  const base64String = await convertBlobToBase64(blobData);

  newGraphSheet.mergeCells(2, 1, 2, 7);
  newGraphSheet.getRow(2).getCell(1).alignment = {
    vertical: 'middle',
    horizontal: 'left',
  };
  newGraphSheet.getRow(2).getCell(1).font = { bold: true, size: 12 };
  newGraphSheet.getRow(2).getCell(1).value = 'Notification summary';

  const generalStyles = {
    font: { bold: true },
    alignment: { horizontal: 'left' },
  };

  for (let rowIndex = 3; rowIndex < 5; rowIndex += 1) {
    newGraphSheet.mergeCells(rowIndex, 1, rowIndex, 2);
    newGraphSheet.mergeCells(rowIndex, 3, rowIndex, 4);
    newGraphSheet.mergeCells(rowIndex, 5, rowIndex, 5);
    Object.assign(newGraphSheet.getRow(rowIndex).getCell(1), generalStyles);
    Object.assign(newGraphSheet.getRow(rowIndex).getCell(3), generalStyles);
    Object.assign(newGraphSheet.getRow(rowIndex).getCell(5), generalStyles);
  }
  newGraphSheet.getRow(3).getCell(1).value = 'Total notifications';
  newGraphSheet.getRow(3).getCell(3).value = 'Total repairs';
  newGraphSheet.getRow(3).getCell(5).value = 'Total mobile numbers supplied';
  newGraphSheet.getRow(4).getCell(1).value =
    reportData?.mobileCount?.recs?.toString() || '';
  newGraphSheet.getRow(4).getCell(3).value =
    reportData?.mobileCount?.repairCount?.toString() || '';
  newGraphSheet.getRow(4).getCell(5).value =
    reportData?.mobileCount?.mobileNumbers?.toString() || '';
  const imageId = workbook.addImage({
    base64: base64String as string,
    extension: 'jpeg',
  });

  newGraphSheet.addImage(imageId, {
    tl: { col: 0, row: 5 },
    ext: { width: 800, height: 250 },
  });

  newGraphSheet.addImage(headerImageId, {
    tl: { col: 0, row: 0 },
    ext: { width: 250, height: 50 },
  });
  graphSheet.state = 'visible';
}
